/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState, useRef, MutableRefObject } from "react";
import { ref, listAll, getDownloadURL, getMetadata, StorageReference, deleteObject } from 'firebase/storage';
import { Link } from "react-router-dom";
import { useDebouncedCallback } from 'use-debounce';
import { AxiosResponse } from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
    faArrowLeft,
    faArrowRight,
    faLevelUpAlt,
    faEye,
    faTimes
} from "@fortawesome/free-solid-svg-icons";

import { Loader } from "../../../components/ui/Loader";
import { useKW2P } from "../../../hooks/useKW2P";
import { UserContext } from "../../../context/UserContext";
import { AuthContext } from "../../../context/AuthContext";
import { MascostasData, Mascota, FuncMap, Adoptante } from "../../../interfaces/mascotasInterfaces";
import {
    mascotaEdad,
    mascotaRaza,
    mascotaSexo,
    mascotaTamano,
} from "../../../helpers/callejeritosFunciones";
import "../../../style.css";


import { Modal, Button } from 'react-bootstrap'

import { useForm, useWatch } from "react-hook-form";
import { DropImagesSmall } from "../../../components/Mascotas/DropImagesSmall";
import { storage } from "../../../firebase/firebaseConfig";
import { DocumentItem } from "../../../components/Mascotas/DocumentItem";




export const MascotaDic = (languaje: string) => [
    {
        key: "adoptado",
        label: languaje === "ES" ? "Adoptadas" : "Adopted"
    },
    {
        key: "adopcion",
        label: languaje === "ES" ? "En Adopción" : "In Adoption"
    },
    {
        key: "rehabilitacion",
        label: languaje === 'ES' ? 'En Rehabilitación' : 'In Rehabilitation'
    },

    {
        key: "eliminado",
        label: languaje === 'ES' ? 'Eliminado' : 'Is deleted',
        hidden: true
    },
    {
        key: "activo",
        label: languaje === 'ES' ? 'Activo' : 'Is active',
        hidden: true
    }
]


const ITEMS_PER_PAGE = 15;

export function MascotasAdotadas() {
    const signalsRef = useRef < FuncMap > ({})
    const { languaje } = useContext(UserContext);
    const [show, setShow] = useState(true);

    const { actualizarCatalogoPublic } = useKW2P();




    const [adoptanteInfo, setAdoptanteInfo] = useState < Adoptante | null > (null);
    const [usuarioMascotaDuenio, setUsuarioMascotaDuenio] = useState < Mascota | null > (null);


    const fetchData = async () => {
        setShow(false)
        setTimeout(() => setShow(true), 0);
    }


    const actualizarDatosMascotas = (body: any) => {
        actualizarCatalogoPublic(body).then(() => {
            fetchData()
        })
    };


    return (
        <>
            <div className="mascotas__container justify-content-start">



                {!!usuarioMascotaDuenio ? (
                    <div className="mascotas__bodyy contenedor_popup">
                        <div className="row">
                            <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th>{languaje === "ES" ? "NOMBRE" : "NAME"}</th>
                                                <th>{languaje === "ES" ? "CORREO" : "EMAIL"}</th>
                                                <th>{languaje === "ES" ? "TELÉFONO" : "PHONE"}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                {/* <td>{usuarioMascota?.nombre}</td>
                                                        <td>{usuarioMascota?.correo}</td>
                                                        <td>{usuarioMascota?.telefono}</td> */}
                                                {/* @ts-ignore */}
                                                <td>{usuarioMascotaDuenio?.dueno_mascota}</td>
                                                {/* @ts-ignore */}
                                                <td>{usuarioMascotaDuenio?.dueno_mascota_correo}</td>
                                                {/* @ts-ignore */}
                                                <td>{usuarioMascotaDuenio?.dueno_mascota_telefono}</td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={_ => setUsuarioMascotaDuenio(null)}
                                                    >
                                                        cerrar
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                {!!adoptanteInfo ? (
                    <div className="mascotas__bodyy contenedor_popup">
                        <div className="row">
                            <div className="col-12">
                                <div className="table-responsive">
                                    <table className="table table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th>{languaje === "ES" ? "NOMBRE" : "NAME"}</th>
                                                <th>{languaje === "ES" ? "CONTACTO" : "CONTACT"}</th>
                                                <th>{languaje === "ES" ? "DIRECCIÓN" : "ADDRESS"}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className="d-flex" style={{ gap: 5 }}>
                                                        <span>{adoptanteInfo?.nombre}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex" style={{ gap: 5 }}>
                                                        <span>{adoptanteInfo?.telefono}</span>
                                                        <span>{adoptanteInfo?.correo}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex" style={{ gap: 5 }}>
                                                        <span>{adoptanteInfo?.domicilio_calle}</span>
                                                        <span>{adoptanteInfo?.domicilio_colonia}</span>
                                                        <span>{adoptanteInfo?.domicilio_cp}</span>
                                                        <span>{adoptanteInfo?.domicilio_estado}</span>
                                                        <span>{adoptanteInfo?.domicilio_ciudad}</span>
                                                        <span>{adoptanteInfo?.domicilio_pais}</span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={_ => setAdoptanteInfo(null)}
                                                    >
                                                        cerrar
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={4}>
                                                    <ContratoAdoptante id={adoptanteInfo?.id} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                {/* @ts-ignore */}
                <ModalMascotasEstado signals={(cb: Function) => signalsRef.current['modal'] = cb} onFinish={() => {
                    fetchData()//implementar funcion
                    // @ts-ignore
                    signalsRef.current['table']?.(true)
                }} />
                {show ? <>
                    <MascotasTable setAdoptanteInfo={setAdoptanteInfo} signalsRef={signalsRef} setUsuarioMascotaDuenio={setUsuarioMascotaDuenio} actualizarDatosMascotas={actualizarDatosMascotas} />
                    <MascotasTable setAdoptanteInfo={setAdoptanteInfo} signalsRef={signalsRef} setUsuarioMascotaDuenio={setUsuarioMascotaDuenio} actualizarDatosMascotas={actualizarDatosMascotas} eliminado />
                </> : null}
            </div>



        </>
    )
}

function ContratoAdoptante({ id }) {
    const modalRef = useRef < any > ();
    const modalSrcRef = useRef < any > ();
    const [docs, setDocs] = useState < DocItem[] > ([]);
    async function openUrlAsBlobInNewTab(url) {

        // Creamos un enlace temporal
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank"; // Abre en nueva pestaña
        a.rel = "noopener noreferrer"; // Mejora seguridad
        a.style.display = "none";

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    const openImageModal = (url: string) => {
        openUrlAsBlobInNewTab(url)

    }



    const buildItem = (itemRef: StorageReference) => {
        return new Promise < any > (async (resolve, reject) => {

            let type: string;
            let url: string;

            let size: number;

            // Get metadata properties
            await getMetadata(itemRef)
                .then((metadata) => {
                    type = metadata.contentType;
                    size = metadata.size;
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });

            await getDownloadURL(itemRef)
                .then((downloadURL) => {
                    url = downloadURL;
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });

            const newItem: DocItem = {
                url,
                type,
                altTag: itemRef.name,
                title: itemRef.name,
                path: itemRef?._location?.path_,
                size,
            };

            resolve(newItem);
        });
    };
    const getContrato = async () => {


        const storageRef = ref(storage, `contrato/${id}`);
        new Promise((resolve, reject) => {
            listAll(storageRef)
                .then((res) => {
                    res.items.forEach(async (itemRef) => {
                        const file = await buildItem(itemRef);
                        resolve(setDocs(oldArray => [...oldArray, file].reduce((v: DocItem[], c: DocItem) => {
                            const index = v.findIndex((f: DocItem) => f.path == c.path)
                            if (index > -1) {
                                v[index] = { ...v[index], ...c }
                            } else {
                                v.push(c)
                            }
                            return v
                        }, [])));
                    });
                }).catch((error) => {
                    console.log(error);
                    reject();
                });
        });

    };

    useEffect(() => {
        getContrato()
    }, [])

    return (<>
        {docs?.map((doc: DocItem) => (<>
            <DocumentItem name={doc.title} size={doc.size} key={doc.path} onClick={() => openImageModal(doc.url)} />
        </>))}
    </>)
}


function MascotasTable({
    eliminado = false,
    signalsRef,
    setUsuarioMascotaDuenio,
    setAdoptanteInfo,
    actualizarDatosMascotas
}: {
    eliminado?: boolean,
    signalsRef: MutableRefObject<FuncMap>,
    setUsuarioMascotaDuenio: Function,
    setAdoptanteInfo?: Function,
    actualizarDatosMascotas: Function
}) {
    const queries = {
        'payload->nombre': ({ value, onChange }: { value: any | string | null, onChange: Function | null }) => (
            <div className="col">

                <input
                    type="text"
                    className="form-control"
                    style={{ minWidth: '300px' }}
                    placeholder={
                        languaje === "ES" ? "Buscar mascota" : "Search pet"
                    }
                    value={value}
                    onChange={v => onChange?.(v.target.value)}
                />

            </div>
        ),
        'payload->nuestro_canal': ({ value, onChange }: { value: any | string | null, onChange: Function | null }) => (
            <div className="col">
                <select
                    className="form-control"
                    style={{ minWidth: '300px' }}
                    value={value}
                    onChange={v => {
                        return onChange?.(v.target.value)
                    }}
                >
                    <option value="" selected>{languaje === 'ES' ? '¿Fue adoptado por medio de Callejeritos?' : 'He was adopted through Callejeritos?'}</option>
                    <option value="SI">{languaje === "ES" ? "SI" : "YES"}</option>
                    <option value="NO">NO</option>
                </select>
            </div>
        )
    }

    const { languaje } = useContext(UserContext);

    const { consultarCatalogo } =
        useKW2P();





    const [totals, setTotals] = useState(0);



    const consultarMascotasEstado = (
        { estado, query, page }:
            { estado?: string, query?: any, page?: number | null }): Promise<AxiosResponse<MascostasData>> => {
        console.log({ estado, query, page })
        return consultarCatalogo({
            schema: "mascotas",
            ...page ? {
                limit: ITEMS_PER_PAGE,
                page: page,
            } : {},

            filter: {
                where: [
                    ...estado ? [{
                        field: "payload->estado",
                        operator: "=",
                        value: estado,
                    }] : [],
                    ...Object.entries(query ?? {}).map(([key, value]) => ({
                        field: key,
                        operator: "like",
                        value: `%${value}%`,
                        collate: "utf8mb4_unicode_ci"
                    })),
                    {
                        field: "payload->eliminado",
                        operator: "!=",
                        value: !eliminado
                    }

                ],
            },
        });

    };

    const fetchData = async () => {
        consultarMascotasEstado({ estado: 'adoptado' })
            .then(({ data: { data } }) => {

                setTotals(data.length)
            })
    };

    useEffect(() => {
        fetchData()
    }, []);
    return (
        < >


            <div className="mascotas__header">
                <p>{languaje === "ES" ? ("Mascotas Adoptadas" + (eliminado ? " Eliminadas" : '')) : ("Adopted Pets")} {` (${totals})`}</p>
            </div>
            <div className="macotas__body">
                <MascotasEstato
                    estado={'adoptado'}
                    setUsuarioMascotaDuenio={setUsuarioMascotaDuenio}
                    setAdoptanteInfo={setAdoptanteInfo}
                    consultarMascotasEstado={consultarMascotasEstado}
                    onUpdateState={signalsRef.current?.['modal'] ?? (() => { })}
                    // @ts-ignore
                    signals={cb => signalsRef.current['table'] = cb}
                    queries={queries}
                    eliminado={eliminado}
                    actualizarDatosMascotas={actualizarDatosMascotas}
                />
            </div>
        </>
    )
}





export function ModalMascotasEstado({ signals, onFinish }: { signals: Function, onFinish: Function }) {
    const [loading, setLoading]= useState<Boolean>(false)
    const ImageCedule = useRef < any > ();
    const { actualizarCatalogoPublic } = useKW2P();
    const { languaje } = useContext(UserContext);
    const [selectedMascota, setSelectedMascota] = useState < Mascota | null > (null);
    const { formState: { errors }, handleSubmit, register, control, setValue, reset } = useForm()
    const estado = useWatch({ control, name: 'estado' })
    const tabs = MascotaDic(languaje).filter(tab => !tab.hidden)
    const nuestro_canal = useWatch({ control, name: 'nuestro_canal' });
    const handleUpdateState = (mascota: Mascota) => {
        reset({})
        setSelectedMascota(mascota);
        setValue('estado', mascota.payload.estado)
        setValue('nuestro_canal', '')
    }
    const formatPhone = (val: string) => {
        const phone = val.replace(/[^0-9.]/g, '');
        const telformated = phone.slice(0, 3) + (phone.length > 3 ? ("-" + phone.slice(3, 6)) : '') + (phone.length > 6 ? ("-" + phone.slice(6)) : '');
        setValue('adoptante.telefono', telformated, { shouldValidate: true, shouldDirty: true });
    };

    const onSubmit = ({ estado, nuestro_canal, adoptante }: { estado: string; nuestro_canal: string; adoptante: any }) => {
        setLoading(true)
        try {
            if (ImageCedule.current && !ImageCedule.current.dropZoneValid()) {
                alert(languaje === 'ES' ? 'Debes subir el documento del contrato' : 'You must upload the contract document');
                setLoading(false)
                return;
            }
            ImageCedule.current && ImageCedule.current.submitFiles(selectedMascota.id);
            actualizarCatalogoPublic({
                id: selectedMascota?.id,
                schema: selectedMascota?.schema,
                payload: {
                    ...selectedMascota?.payload ?? {},
                    estado,
                    eliminado: false,
                    // eliminado: estado === 'adoptado'?false:selectedMascota?.payload?.eliminado,
                    nuestro_canal,
                    adoptante: adoptante ? adoptante : undefined,
                }
            }).then(({ data: { data } }) => {
                onFinish()
                setSelectedMascota(null)
            }).catch(err=>{
                debugger
            }).finally(()=>{
                setLoading(false);
            })
        } catch (error) {
            debugger
         }
    }
    useEffect(() => {
        signals(handleUpdateState)
    }, [])
    return (
        <Modal style={{'zIndex':1050}} size={nuestro_canal === 'SI' ? "xl" : undefined} centered show={!!selectedMascota} onHide={() => setSelectedMascota(null)}>
            <Modal.Header style={{ borderBottom: 'unset' }}>
                <Modal.Title>
                    {selectedMascota?.payload?.nombre ?? ''}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="row">
                <div className="col-12 mt-2">
                    <label htmlFor="estado">{languaje === 'ES' ? 'Estado' : 'State'}</label>
                    <select
                        id="estado"
                        className="form-control"
                        {...register('estado', {
                            required: languaje === 'ES' ? 'Elije una opción' : 'Choose one option',
                            validate: value =>
                                value !== selectedMascota?.payload?.estado
                                    ? true
                                    : languaje === 'ES'
                                        ? 'Debes seleccionar un estado diferente'
                                        : 'You must select a different state',
                        })}
                    >
                        {tabs.map((tab) => (
                            <option key={tab.key} value={tab.key}>{tab.label}</option>
                        ))}
                    </select>
                    {errors.estado && <small className="text-danger">{errors.estado.message}</small>}
                </div>
                {selectedMascota?.payload?.eliminado && (
                    <div className="col-12 mt-2 text-danger">
                        Esta mascota está marcada como eliminada. Si cambias su estado a "Adoptada", la casilla de "Eliminado" se desmarcará automáticamente.
                    </div>
                )}

                {selectedMascota?.payload?.estado !== estado && estado === 'adoptado' && (
                    <>
                        <div className="col-12 mt-2">
                            <label htmlFor="nuestro_canal">{languaje === 'ES' ? '¿Fue adoptado por medio de Callejeritos?' : 'He was adopted through Callejeritos?'}</label>
                            <select
                                id="nuestro_canal"
                                className="form-control"
                                {...register('nuestro_canal', {
                                    required: languaje === 'ES' ? 'Elije una opción' : 'Choose one option',
                                })}
                            >
                                <option value="" disabled hidden>{languaje === 'ES' ? 'Elije una opción' : 'Choose one option'}</option>
                                <option value="SI">{languaje === 'ES' ? 'SI' : 'YES'}</option>
                                <option value="NO">NO</option>
                            </select>
                            {errors.nuestro_canal && <small className="text-danger">{errors.nuestro_canal.message}</small>}
                        </div>

                        {nuestro_canal === 'SI' && (
                            <>
                                <div className="col-12 mt-2">
                                    <label>Nombre del Adoptante</label>
                                    <input className="form-control" {...register('adoptante.nombre', { required: languaje === 'ES' ? 'El nombre es requerido' : 'The name is required' })} />
                                    {errors.adoptante?.nombre && <small className="text-danger">{errors.adoptante.nombre.message}</small>}
                                </div>
                                <div className="col-6 mt-2">
                                    <label>Teléfono</label>
                                    <input maxLength={12} type="tel" className="form-control" {...register('adoptante.telefono', {
                                        required: languaje === 'ES' ? 'El teléfono es requerido' : 'The phone is required',
                                        maxLength: { value: 12, message: languaje === 'ES' ? 'Ingresa un teléfono válido' : 'Enter a valid celphone' },
                                        minLength: { value: 12, message: languaje === 'ES' ? 'Ingresa un teléfono válido' : 'Enter a valid celphone' },
                                        onChange: (e) => formatPhone(e.target.value)
                                    })} />
                                    {errors.adoptante?.telefono && <small className="text-danger">{errors.adoptante.telefono.message}</small>}
                                </div>
                                <div className="col-6 mt-2">
                                    <label>Correo</label>
                                    <input type="email" className="form-control" {...register('adoptante.correo', {
                                        required: languaje === 'ES' ? 'El correo es requerido' : 'The email is required',
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: languaje === 'ES' ? 'Ingresa un correo válido' : 'Enter a valid email'
                                        }
                                    })} />
                                    {errors.adoptante?.correo && <small className="text-danger">{errors.adoptante.correo.message}</small>}
                                </div>
                                <div className="col-12 mt-2">
                                    <label>Calle</label>
                                    <input className="form-control" {...register('adoptante.domicilio_calle', {
                                        required: languaje === 'ES' ? 'La calle es requerida' : 'The street is required',
                                        pattern: {
                                            value: /^([A-Za-zÁÉÍÓÚÑáéíóúñ0-9°#.,'\"\- ]+)\s+(\d+[A-Za-z0-9\-]*)\s*(Int\.?|Interior)?\s*([A-Za-z0-9\-]*)?$/,
                                            message: languaje === 'ES' ? 'Ingresa una calle válida' : 'Enter a valid street'
                                        }
                                    })} />
                                    {errors.adoptante?.domicilio_calle && <small className="text-danger">{errors.adoptante.domicilio_calle.message}</small>}
                                </div>
                                <div className="col-8 mt-2">
                                    <label>Colonia</label>
                                    <input className="form-control" {...register('adoptante.domicilio_colonia', {
                                        required: languaje === 'ES' ? 'La colonia es requerida' : 'The neighborhood is required'
                                    })} />
                                    {errors.adoptante?.domicilio_colonia && <small className="text-danger">{errors.adoptante.domicilio_colonia.message}</small>}
                                </div>
                                <div className="col-4 mt-2">
                                    <label>Código Postal</label>
                                    <input maxLength={5} className="form-control" {...register('adoptante.domicilio_cp', {
                                        required: languaje === 'ES' ? 'El código postal es requerido' : 'The postal code is required',
                                        pattern: {
                                            value: /^\d{5}$/,
                                            message: languaje === 'ES' ? 'Ingresa un código postal válido' : 'Enter a valid postal code'
                                        }
                                    })} />
                                    {errors.adoptante?.domicilio_cp && <small className="text-danger">{errors.adoptante.domicilio_cp.message}</small>}
                                </div>
                                <div className="col-4 mt-2">
                                    <label>Estado</label>
                                    <input className="form-control" {...register('adoptante.domicilio_estado', {
                                        required: languaje === 'ES' ? 'El estado es requerido' : 'The state is required'
                                    })} />
                                    {errors.adoptante?.domicilio_estado && <small className="text-danger">{errors.adoptante.domicilio_estado.message}</small>}
                                </div>
                                <div className="col-4 mt-2">
                                    <label>Ciudad</label>
                                    <input className="form-control" {...register('adoptante.domicilio_ciudad', {
                                        required: languaje === 'ES' ? 'La ciudad es requerida' : 'The city is required'
                                    })} />
                                    {errors.adoptante?.domicilio_ciudad && <small className="text-danger">{errors.adoptante.domicilio_ciudad.message}</small>}
                                </div>
                                <div className="col-4 mt-2">
                                    <label>País</label>
                                    <input className="form-control" {...register('adoptante.domicilio_pais', {
                                        required: languaje === 'ES' ? 'El país es requerido' : 'The country is required'
                                    })} />
                                    {errors.adoptante?.domicilio_pais && <small className="text-danger">{errors.adoptante.domicilio_pais.message}</small>}
                                </div>
                                <div className="col-12 mt-2">
                                    <label>Contrato de adopción (PDF)</label>
                                    <DropImagesSmall path="contrato" ref={ImageCedule} mascota={selectedMascota} />
                                </div>
                            </>
                        )}
                    </>
                )}


            </Modal.Body>

            <Modal.Footer style={{ borderTop: 'unset' }}>
                <Button disabled={loading} variant="secondary" onClick={!loading ?_ => setSelectedMascota(null):null}>
                    {languaje === 'ES' ? 'Cancelar' : 'Cancel'}
                </Button>
                {/* @ts-ignore */}
                <Button disabled={loading} variant="primary" onClick={!loading ?handleSubmit(onSubmit, console.log):null}>
                   {loading ? 'Loading…' :(languaje === 'ES' ? 'Guardar' : 'Save')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function MascotasEstato({
    estado,
    setAdoptanteInfo,
    setUsuarioMascotaDuenio,
    consultarMascotasEstado,
    onUpdateState,
    signals,
    queries,
    eliminado,
    actualizarDatosMascotas,
}: {
    estado: string;
    setAdoptanteInfo?: Function;
    setUsuarioMascotaDuenio: Function;
    consultarMascotasEstado: Function;
    onUpdateState: Function;
    signals: Function;
    queries: any;
    eliminado?: boolean;
    actualizarDatosMascotas?: Function;
}) {
    const { languaje } = useContext(UserContext);
    const { handleError, setLoading, isLoading } = useContext(AuthContext);


    const [page, setPage] = useState < number > (1);
    const [lastPage, setLastPage] = useState < number > (0);
    const [query, setQuery] = useState < any > ({});
    const [mascotas, setMascotas] = useState < Mascota[] > ([]);



    const banderaDevolver = (mascota: Mascota) => {
        console.log(mascota);
        const fechaActual = new Date();
        let eliminado = mascota.payload.eliminado;
        let fecha_creado = mascota.payload.fecha_creado;
        eliminado = false;
        mascota.payload.fecha_eliminado = "";
        console.log("notificacion", mascota.payload);
        // let suma15dias= 15*24*60*60*1000;
        // let sumandoDias = new Date(new Date(fecha_creado).getTime()+ suma15dias);
        // console.log("fecha_creado", sumandoDias.toLocaleDateString());
        // console.log("fecha_creado",new Date(new Date().getTime()+ suma15dias));
        // sumando 15 dias para la fecha de notificación
        let suma15dias = 15 * 24 * 60 * 60 * 1000;
        let sumandoDias = new Date(new Date(fechaActual).getTime() + suma15dias);
        let day: any = sumandoDias.getDate();
        if (day < 10) {
            day = "0" + day;
        }
        let month: any = sumandoDias.getMonth() + 1;
        if (month < 10) {
            month = "0" + month;
        }
        let year = sumandoDias.getFullYear();
        console.log("day", `${year}-${month}-${day}`);

        // sumando 35 días para la fecha de expiración
        let suma35dias = 35 * 24 * 60 * 60 * 1000;
        let sumandoDiasExpiracion = new Date(
            new Date(fechaActual).getTime() + suma35dias
        );
        let dayExpiracion: any = sumandoDiasExpiracion.getDate();
        if (dayExpiracion < 10) {
            dayExpiracion = "0" + dayExpiracion;
        }
        let monthExpiracion: any = sumandoDiasExpiracion.getMonth() + 1;
        if (monthExpiracion < 10) {
            monthExpiracion = "0" + monthExpiracion;
        }
        let yearExpiracion = sumandoDiasExpiracion.getFullYear();
        console.log(
            "sumandoDiasExpiracion",
            `${yearExpiracion}-${monthExpiracion}-${dayExpiracion}`
        );
        const body = {
            schema: "mascotas",
            id: mascota?.id,
            payload: {
                ...mascota.payload,
                eliminado: eliminado,
                fecha_notificacion: `${year}-${month}-${day}`,
                fecha_expiracion: `${yearExpiracion}-${monthExpiracion}-${dayExpiracion}`,
            },
        };
        setLoading(true);
        return actualizarDatosMascotas?.(body);
    };


    const obtenerIdDueno = (event: any) => {
        let idUsuario = event.target.value;
        console.log("valor_dueño", idUsuario);
        const { payload: usr } = mascotas.find((mascota: Mascota) => Number(mascota.id) === Number(idUsuario)) as Mascota;
        setUsuarioMascotaDuenio(usr);
    };
    const obtenerAdotante = (mascota: Mascota) => {

        if (mascota?.payload?.adoptante && setAdoptanteInfo) {
            setAdoptanteInfo({ ...mascota.payload.adoptante, id: mascota.id });
        }
    }

    const fetchData = async (sinLoader = false) => {


        try {
            !sinLoader && setLoading(true);
            const {
                data: {
                    data,
                    paginate
                },
            } = await consultarMascotasEstado({ estado, query, page, sinLoader });


            setLastPage(paginate?.last_page ?? 0);
            console.log("mascotas", data)
            // @ts-ignore
            setMascotas(data.map((m, i) => ({ ...m, index: (page - 1) * ITEMS_PER_PAGE + 1 + i })));

            setLoading(false);
        } catch (err: any) {
            setLoading(false);
            handleError(err);
        }
    };
    const handleSearch = useDebouncedCallback(() => {
        fetchData(true)
    }, 500);
    useEffect(() => {
        handleSearch()
    }, [query]);
    useEffect(() => {
        fetchData();
        signals(fetchData)
    }, [estado, page,]);
    return (<>

        <div className="row w-100 mb-2">

            {Object.entries(queries).map(([key, Value]) => (
                // @ts-ignore
                <Value
                    key={key}
                    value={query[key]}
                    onChange={(v: any) => {
                        setQuery((q: any) => ({ ...q, [key]: v }))
                    }}
                />
            ))}

        </div>

        <div className="row">
            <div className="col-12">
                <div className="table-responsive">
                    <table className="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{languaje === "ES" ? "NOMBRE" : "NAME"}</th>
                                {estado === 'adoptado' ?
                                    <th>
                                        {languaje === "ES" ? "POR CALLEJERITOS" : "BY CALLEJERITOS"}
                                    </th>
                                    : null}
                                <th>
                                    {languaje === "ES" ? "FECHA CREACIÓN" : "CREATED AT"}
                                </th>
                                <th>{languaje === "ES" ? "RAZA" : "BREED"}</th>
                                <th>COLOR</th>
                                <th>{languaje === "ES" ? "EDAD" : "AGE"}</th>
                                <th>{languaje === "ES" ? "SEXO" : "GENDER"}</th>
                                <th>{languaje === "ES" ? "TAMAÑO" : "SIZE"}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {console.log("array",mascotasPaginadas)} */}
                            {mascotas.length === 0 ?
                                (<tr>
                                    <td colSpan={10} className="text-center" style={{ height: 150, placeContent: 'center' }}>
                                        {languaje === "ES" ? "No hay mascotas" : "No pets"}
                                    </td>
                                </tr>)
                                :
                                mascotas.map((mascota: Mascota) => (
                                    // mascota.payload.eliminado === "" || mascota.payload.eliminado === false ?
                                    <tr dataKey={mascota.id} key={mascota.id}>
                                        <td>{mascota.index}</td>
                                        <td>{mascota.payload.nombre}</td>
                                        {estado === 'adoptado' ?
                                            <td>
                                                {mascota.payload.nuestro_canal}
                                            </td>
                                            : null}
                                        <td>{mascota.created_at.slice(0, -17)}</td>

                                        <td>{mascotaRaza(mascota.payload.raza, languaje)}</td>
                                        <td>{mascota.payload.color}</td>
                                        <td>{mascotaEdad(mascota.payload.edad, mascota.created_at, languaje)}</td>
                                        <td>{mascotaSexo(mascota.payload.sexo, languaje)}</td>
                                        <td>{mascotaTamano(mascota.payload.tamano, languaje)}</td>
                                        <td>

                                            <div className="d-flex justify-content-end align-items-center" style={{ gap: '5px', flexWrap: 'wrap', flexDirection: 'row' }}>


                                                {mascota.payload.nuestro_canal === 'SI' && mascota.payload.adoptante ? <>
                                                    <button
                                                        value={mascota.id}
                                                        className="btn btn-sm btn-outline-primary"
                                                        onClick={() => obtenerAdotante(mascota)}
                                                        style={{ placeContent: 'center' }}
                                                    >
                                                        <FontAwesomeIcon icon={faEye as IconProp} />
                                                    </button>

                                                </> : null}
                                                <button
                                                    value={mascota.id}
                                                    className="btn btn-sm btn-outline-info"
                                                    onClick={_ => onUpdateState(mascota)}
                                                    style={{ placeContent: 'center' }}
                                                >
                                                    {languaje === "ES" ? "Cambiar estatus" : "Change status"}
                                                </button>
                                                {eliminado ? <div className="d-flex justify-content-end">

                                                    <button
                                                        onClick={() => banderaDevolver(mascota)}
                                                        className="btn btn-sm btn-outline-primary"
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faLevelUpAlt as IconProp}
                                                        />
                                                    </button>
                                                </div> : null}
                                                <button
                                                    value={mascota.id}
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={obtenerIdDueno}
                                                    style={{ placeContent: 'center' }}
                                                >
                                                    {languaje === "ES" ? "Dueño" : "Owner"}
                                                </button>
                                                <Link
                                                    to={`/mascotas/adoptada/${mascota.id}`}
                                                    className="btn btn-sm btn-detalles"
                                                    style={{ placeContent: 'center' }}
                                                >
                                                    {languaje === "ES" ? "Detalles" : "Details"}
                                                </Link>
                                                {mascota.payload.expediente_id && (
                                                    <Link
                                                        to={`/expediente-azul/expediente/${mascota.payload.nombre}/${mascota.payload.expediente_id}`}
                                                        className="btn btn-sm btn-outline-primary mr-2 font-weight-bold"
                                                        style={{ placeContent: 'center' }}
                                                    >
                                                        {languaje === "ES" ? "Expediente" : "File"}
                                                    </Link>
                                                )}



                                            </div>
                                        </td>
                                    </tr>
                                    // : null
                                ))}
                            {/* {console.log(usuarioMascota)} */}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-6"></div>
            <div className="col-6">
                <div className="row align-items-center">
                    <div className="col">
                        {/* <button className='form-control' onClick={prevHandle}>{languaje === 'ES' ? 'página anterior' : 'previous page'}</button> */}
                        {page > 1 ?
                            <button className="form-control" onClick={_ => setPage(p => Number(p) - 1)}>
                                <FontAwesomeIcon icon={faArrowLeft as IconProp} />
                            </button>
                            : null}
                    </div>
                    <div>
                        {page} de {lastPage}
                    </div>
                    <div className="col">
                        {/* <button className='form-control' onClick={nextHandler}>{languaje === 'ES' ? 'siguiente página' : 'next page'}</button> */}
                        {page < lastPage ?
                            <button className="form-control" onClick={_ => setPage(p => Number(p) + 1)}>
                                <FontAwesomeIcon icon={faArrowRight as IconProp} />
                            </button>
                            : null}
                    </div>
                </div>
            </div>
        </div>
        {isLoading && <Loader />}
    </>)
}


interface DocItem {
    url: string;
    type: string;
    altTag: string;
    title: string;
    path: string;
    size: number;
}
